import usersManualActionTypes from '../../constants/actions/profile/usersManual'

export default {
  getUserManualUrl: (resolve, reject) => ({ type: usersManualActionTypes.GET_USERS_MANUAL_URL, resolve, reject })
}
